import {
  FETCH_NEWSROOM_ASSETS,
  FETCH_NEWSROOM_ASSETS_FULFILLED,
  FETCH_NEWSROOM_ASSETS_REJECTED,
  FETCH_NEWSROOM_NEWS,
  FETCH_NEWSROOM_NEWS_FULFILLED,
  FETCH_NEWSROOM_NEWS_REJECTED,
  FETCH_SINGLE_NEWS_ASSETS,
} from 'b2b-apps/shop/content/redux/newsroom/actionTypes';
import {
  FetchNewsroomAssetsAction,
  FetchNewsroomAssetsFulfilledAction,
  FetchNewsroomAssetsRejectedAction,
  FetchNewsroomNewsAction,
  FetchNewsroomNewsFulfilledAction,
  FetchNewsroomNewsRejectedAction,
  FetchSingleNewsAssetsAction,
} from 'b2b-apps/shop/content/redux/newsroom/types';
import { NewsroomAssetsType, NewsroomNewsType } from 'b2b-common/core/content/api/Newsroom.types';

const fetchNewsroomAssets = (page?: number): FetchNewsroomAssetsAction => ({
  type: FETCH_NEWSROOM_ASSETS,
  payload: {
    page,
  },
});

const fetchNewsroomAssetsFulfilled = (
  data: NewsroomAssetsType,
): FetchNewsroomAssetsFulfilledAction => ({
  type: FETCH_NEWSROOM_ASSETS_FULFILLED,
  payload: { data },
});

const fetchNewsroomAssetsRejected = (
  error: ErrorType,
): FetchNewsroomAssetsRejectedAction => ({
  type: FETCH_NEWSROOM_ASSETS_REJECTED,
  payload: {
    error,
  },
});

const fetchNewsroomNews = (page?: number): FetchNewsroomNewsAction => ({
  type: FETCH_NEWSROOM_NEWS,
  payload: {
    page,
  },
});

const fetchNewsroomNewsFulfilled = (
  response: NewsroomNewsType,
): FetchNewsroomNewsFulfilledAction => ({
  type: FETCH_NEWSROOM_NEWS_FULFILLED,
  payload: {
    data: response,
  },
});

const fetchNewsroomNewsRejected = (
  error: ErrorType,
): FetchNewsroomNewsRejectedAction => ({
  type: FETCH_NEWSROOM_NEWS_REJECTED,
  payload: {
    error,
  },
});

const fetchSingleNewsAssets = (
  entriesIds: string[],
): FetchSingleNewsAssetsAction => ({
  type: FETCH_SINGLE_NEWS_ASSETS,
  payload: {
    entriesIds,
  },
});

export {
  fetchNewsroomAssets,
  fetchNewsroomAssetsFulfilled,
  fetchNewsroomAssetsRejected,
  fetchNewsroomNews,
  fetchNewsroomNewsFulfilled,
  fetchNewsroomNewsRejected,
  fetchSingleNewsAssets,
};
